// extracted by mini-css-extract-plugin
export var bIndexAbout = "yd";
export var bIndexAbout__bg = "zd";
export var bIndexAbout__inner = "Ad";
export var animationMarquee = "Bd";